module.exports = __webpack_public_path__ + "static/media/Software_Architecture_Document.4097c4f2.pdf";